// extracted by mini-css-extract-plugin
export default {"box":"UserMenu_box__lNDgg","email":"UserMenu_email__xoBAv","navList":"UserMenu_navList__GZsqJ","navItem":"UserMenu_navItem__DPlQd","link":"UserMenu_link__d6eY9"};